import React, { useState, useEffect } from "react";
import { Col, Card } from "reactstrap";
import DashGauge from "./DashGauge";
import { readingsLatestForLocation } from "../../../../api/readings";
import Loader from "../../../common/Loader";
import WidgetDropdownMenu from "../../../common/WidgetDropdownMenu";
import local from "../../../../localization/strings";

const DashMeter = ({ locationId, latestReadings, noDataAlarms }) => {
	const [loading, setLoading] = useState(true);
	const [reading, setReading] = useState({});
	const [bgColour, setBgColour] = useState("");

	useEffect(() => {
		let isSubscribed = true;
		async function fetchMeterData() {
			const data = await readingsLatestForLocation(locationId);

			if (isSubscribed) {
				if (data.length === 0) {
					setReading(undefined);
				} else {
					setReading(...data);
				}

				setLoading(false);
			}
		}

		const latestReading = (latestReadings || []).find((x) => x.locationId === parseInt(locationId));

		if (latestReading) {
			setReading(latestReading);
			setLoading(false);
		} else {
			fetchMeterData();
		}

		let alarmColour = "";
		const noDataAlarm = noDataAlarms.find((x) => x.locationId === parseInt(locationId));
		let noDataAlarmType = "";
		if (noDataAlarm) {
			noDataAlarmType = noDataAlarm.clearedBy ? "widgetInAlarmCleared" : "widgetInAlarm";
		}

		if (typeof latestReading?.logging === "boolean" && !latestReading?.logging) {
			alarmColour = "None";
		} else {
			switch (latestReading?.alarmType || "") {
				case "MainLo":
				case "MainHi":
					alarmColour = latestReading?.clearedBy ? "widgetInAlarmCleared" : "widgetInAlarm";
					break;
				default:
					break;
			}
		}

		setBgColour("");
		if (alarmColour !== "None") {
			if (alarmColour === "widgetInAlarm" || noDataAlarmType === "widgetInAlarm") {
				setBgColour("widgetInAlarm");
			} else if (alarmColour === "widgetInAlarmCleared" || noDataAlarmType === "widgetInAlarmCleared") {
				setBgColour("widgetInAlarmCleared");
			}
		}

		return () => (isSubscribed = false);
	}, [locationId, latestReadings, noDataAlarms]);

	if (!reading) {
		return null;
	}

	return (
		<Col className="col-12 col-sm-6 col-lg-3 mb-2 d-flex align-items-stretch">
			<Card className={`rounded-soft ${bgColour} dash-border-grey w-100`}>
				{reading && <WidgetDropdownMenu color="secondary" className="white-dots" size="sm" tag="div" options={[{ name: local.TF_View_Chart, locationId: reading.locationId, groupId: reading.groupId }]} />}
				{loading ? (
					<div className="ml-2">
						<Loader />
					</div>
				) : (
					<>{reading ? <DashGauge reading={reading} textColour="#46505e" /> : <div>Failed To Load</div>}</>
				)}
			</Card>
		</Col>
	);
};

export default DashMeter;
